import queryClient from 'api/queryClient'
import { isNotificationsQuestQueryKey } from './notificationQuestQueryKeys.js'

export { isNotificationsQuestQueryKey }

export function removeInactiveNotificationQuestQueries() {
    queryClient.removeQueries({
        queryKey: ['quests'],
        predicate: query =>
            isNotificationsQuestQueryKey(query.queryKey) && query.getObserversCount() === 0,
    })
}
